import React from 'react';
import {
  Button,
  Dropdown,
  FluidButtonLayout,
  Form,
  Gutter,
  Input,
  SectionHeader,
} from '@axiom/ui';

import { LegacyLawSchoolsApi } from '../../api/legacy-law-schools-api';

import {
  AdminModalLawSchoolsFormSchema,
  type AdminModalLawSchoolsFormValues,
} from './admin-modal-law-schools-form-schema';

export type AdminModalLawSchoolsFormProps = {
  id: string | null;
  initialValues: AdminModalLawSchoolsFormValues;
  lawSchoolRanks: Array<{ label: string; value: string }>;
  onCancel: () => void;
};

export const AdminModalLawSchoolsForm = ({
  id,
  initialValues,
  lawSchoolRanks,
  onCancel,
}: AdminModalLawSchoolsFormProps) => {
  return (
    <Form
      name="LAW_SCHOOL_MANAGEMENT_FORM"
      schema={AdminModalLawSchoolsFormSchema}
      initialValues={initialValues}
      onSubmit={async (_changed, _actions, values) => {
        await (id
          ? LegacyLawSchoolsApi.updateLawSchool({ id, body: values })
          : LegacyLawSchoolsApi.createLawSchool({ body: values }));
      }}
    >
      {({ fireSubmit }) => (
        <>
          <Gutter bottom="16px">
            <SectionHeader name="LAW_SCHOOL_FORM_HEADER">
              {id ? 'Edit School' : 'Add School'}
            </SectionHeader>
          </Gutter>
          <Input name="name" label="School Name" />
          <Gutter bottom="16px" />
          <Dropdown
            name="tags"
            label="School Rank"
            options={lawSchoolRanks}
            displayKey="label"
            valueKey="value"
          />
          <Gutter top="16px">
            <FluidButtonLayout>
              <Button
                name="CANCEL"
                onClick={() => {
                  onCancel();
                }}
                variation="outline"
              >
                Cancel
              </Button>
              <Button name="SUBMIT" onClick={fireSubmit}>
                Save
              </Button>
            </FluidButtonLayout>
          </Gutter>
        </>
      )}
    </Form>
  );
};
